// extracted by mini-css-extract-plugin
export default {"content":"TextMarkup_content__GYAwQ"};